/* eslint-disable */
// @ts-nocheck
// import Script from "next/script";
import {
  PartnerPlatforms,
  ONE_TRUST_GDPR_COUNTRIES_LIST,
  ONE_TRUST_OPT_OUT_CONTRIES
} from '../constants/stringConstants';
import {
  getCookie,
  getLocalStorage,
  getSessionStorage
} from '../browserStorageHandler';
import { isServer, mobileCheckForDeviceAuth } from '../common';
import {
  USER_ID,
  GUEST_TOKEN,
  UTM_SOURCE
} from '../constants/localStorageConstants';

import {
  AppsflyerBannerKey,
  AppsflyerWebKey
} from '../constants/utilConstants';
import { comscore } from '../analytics';
import { fbpixel } from '../analytics/fbpixel';
import {
  timeEvent,
  registerSuperProperty,
  setPeopleProperty
} from '../analytics/mixpanel/mixpanelEventsHelper';
import { mixpanelObject } from '../analytics/mixpanel/mixpanel';
import { clevertapWebpushMethod } from '../analytics/clevertap/clevertapHelper';
import { trueCallerUrl } from '../UrlGenerator';
import { isWebView } from '../CheckDeviceType';
import { PARTNER, WEBVIEW } from '../constants/cookieConstants';
import {
  setCustomAttribute,
  trackAppVersion
} from '../analytics/newrelic/RUMHelper';

const PIXEL_EVENTS = [];

// export function GtmScriptAdder() {
export const GtmScriptAdder = (countryCode) => {
  !(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);

    if (countryCode !== 'IN') {
      //For One Trust Gtag
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied',
        security_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        region: ONE_TRUST_GDPR_COUNTRIES_LIST,
        wait_for_update: 500
      });

      gtag('consent', 'default', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        region: ONE_TRUST_OPT_OUT_CONTRIES,
        wait_for_update: 500
      });

      gtag('consent', 'default', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });

      gtag('js', new Date());
      gtag('config', process.env.GTM_ID);
      // OneTrust Gtag end
    }
  })(window, document, 'script', 'dataLayer', process.env.GTM_ID);
  return null;
};

export const adsScriptGenerator = () => {
  const adsScript = document.getElementById('adScript');
  // const adsAdfoxScript = document.getElementById('adfoxAdScript');
  const googletagServices = document.getElementById('googleTagScript');
  // if (isCountryCIS(countryCode, RUCISCOUNTRYLIST) && !adsAdfoxScript) {
  //   const ads = document.createElement('script');
  //   ads.setAttribute('type', 'text/javascript');
  //   ads.setAttribute('id', 'adfoxadScript');
  //   ads.setAttribute('crossorigin', 'anonymous');
  //   ads.setAttribute('src', 'https://yastatic.net/pcode/adfox/loader.js');
  //   ads.setAttribute('defer', 'defer');
  //   document.head.appendChild(ads);
  // } else
  if (!adsScript) {
    const ads = document.createElement('script');
    ads.setAttribute('type', 'text/javascript');
    ads.setAttribute('id', 'adScript');
    ads.defer = true;
    ads.setAttribute(
      'src',
      'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
    );
    ads.setAttribute('defer', 'defer');
    document.head.appendChild(ads);
  }
  if (!googletagServices) {
    const googleTag = document.createElement('script');
    googleTag.setAttribute('id', 'googleTagScript');
    googleTag.defer = true;
    googleTag.setAttribute(
      'src',
      'https://www.googletagservices.com/tag/js/gpt.js'
    );
    googleTag.setAttribute('defer', 'defer');
    document.head.appendChild(googleTag);
  }
  return null;
};

export const MixpanelScriptAdder = (countryCode = 'IN') => {
  if (typeof window === 'undefined') {
    return;
  }
  (function (c, a) {
    if (!a.__SV) {
      var b = window;
      try {
        var d,
          m,
          j,
          k = b.location,
          f = k.hash;
        d = function (a, b) {
          // eslint-disable-next-line no-cond-assign
          return (m = a.match(RegExp(b + '=([^&]*)'))) ? m[1] : null;
        };
        f &&
          d(f, 'state') &&
          ((j = JSON.parse(decodeURIComponent(d(f, 'state')))),
          'mpeditor' === j.action &&
            (b.sessionStorage.setItem('_mpcehash', f),
            history.replaceState(
              j.desiredHash || '',
              c.title,
              k.pathname + k.search
            )));
      } catch (n) {
        console.error(n);
      }
      var l, h;
      window.mixpanel = a;
      a._i = [];
      a.init = function (b, d, g) {
        function c(b, i) {
          var a = i.split('.');
          2 == a.length && ((b = b[a[0]]), (i = a[1]));
          b[i] = function () {
            b.push([i].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var e = a;
        'undefined' !== typeof g ? (e = a[g] = []) : (g = 'mixpanel');
        e.people = e.people || [];
        e.toString = function (b) {
          var a = 'mixpanel';
          'mixpanel' !== g && (a += '.' + g);
          b || (a += ' (stub)');
          return a;
        };
        e.people.toString = function () {
          return e.toString(1) + '.people (stub)';
        };
        l =
          'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(
            ' '
          );
        for (h = 0; h < l.length; h++) c(e, l[h]);
        var f = 'set set_once union unset remove delete'.split(' ');
        e.get_group = function () {
          function a(c) {
            b[c] = function () {
              call2_args = arguments;
              call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
              e.push([d, call2]);
            };
          }
          for (
            var b = {},
              d = ['get_group'].concat(
                Array.prototype.slice.call(arguments, 0)
              ),
              c = 0;
            c < f.length;
            c++
          )
            a(f[c]);
          return b;
        };
        a._i.push([b, d, g]);
      };
      a.__SV = 1.2;
      b = c.createElement('script');
      b.type = 'text/javascript';
      b.defer = 'defer';
      b.onload = function () {
        //   campaignParams();
        timeEvent();
        // mixpanelObject.registerSuperProperty();
        registerSuperProperty();
        setPeopleProperty();
        mixpanelObject.triggerDefferedEvents();
      };
      b.src = `${process.env.PUBLIC_URL}/mixpanelScript.js?ver=${process.env.APP_VERSION}`;
      /**
       * Order of scripts matters. We need onetrust to be loaded first, followed by Newrelic.
       * All other scripts should be added afterwards.
       */
      d = c.getElementsByTagName('script')[2];
      d.parentNode.insertBefore(b, d);
    }
  })(document, window.mixpanel || []);
  const mixpanelId =
    countryCode === 'IN'
      ? process.env.MIXPANEL_ID
      : process.env.MIXPANEL_GlOBAL_ID;
  window.mixpanel.init(mixpanelId, {
    persistence: 'localStorage',
    cross_subdomain_cookie: false,
    track_pageview: false
  });
  return null;
};

export const castScriptAdder = () => {
  const lcf = document.createElement('script');
  lcf.type = 'text/javascript';
  lcf.id = 'loadCastFramework';
  lcf.src =
    'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';

  const crf = document.createElement('script');
  crf.type = 'text/javascript';
  crf.id = 'castReceiverFramework';
  crf.src =
    '//www.gstatic.com/cast/sdk/libs/caf_receiver/v3/cast_receiver_framework.js';

  const castHelperScript = document.createElement('script');
  castHelperScript.type = 'text/javascript';
  castHelperScript.id = 'castHelper';
  castHelperScript.innerText = `window["__onGCastApiAvailable"] = function(isAvailable) {
    if (isAvailable && chrome?.cast?.AutoJoinPolicy?.ORIGIN_SCOPED) {
      initializeCastApi();
    }
  };
  initializeCastApi = function() {
    window.isCastAvailable = true;
    cast.framework.CastContext.getInstance().setOptions({
      receiverApplicationId: "${process.env.CHROMECAST_APPLICATION_ID}",
      autoJoinPolicy: chrome.cast?.AutoJoinPolicy.ORIGIN_SCOPED,
      androidReceiverCompatible : true,
      resumeSavedSession : true
    });
  }`;
  document.head.appendChild(lcf);
  document.head.appendChild(crf);
  document.head.appendChild(castHelperScript);
};

export const defferedThirdPartyScriptsAdder = (countryCode) => {
  //TODO: Not sure if we need this `isDefferedScriptsAdded` check on window object.
  if (typeof window !== 'undefined' && !window.isDefferedScriptsAdded) {
    window.isDefferedScriptsAdded = true;
    comscore();
    fbpixel();
    jusPayScriptAdder();
    !window.location.pathname.includes('/b2b') && ctScriptAdder(countryCode);
  }
  return null;
};

export const appsFlyerScriptAdder = () => {
  if (
    window.location.search.substring(1).includes(PartnerPlatforms.TATASKY) ||
    getSessionStorage(UTM_SOURCE) === PartnerPlatforms.TATASKY_PARTNER ||
    isWebView()
  ) {
    return true;
  }
  if (
    !window.navigator.userAgent.toLowerCase().match(/tv/i) &&
    !(
      (getCookie(WEBVIEW) === 'true' &&
        getCookie(PARTNER) === PartnerPlatforms.SAMSUNG_MY_GALAXY_APP) ||
      window.location.pathname.includes('/b2b')
    ) &&
    !mobileCheckForDeviceAuth()
  ) {
    !(function (t, e, n, s, a, c, i, o, p) {
      (t.AppsFlyerSdkObject = a),
        (t.AF =
          t.AF ||
          function () {
            (t.AF.q = t.AF.q || []).push(
              [Date.now()].concat(Array.prototype.slice.call(arguments))
            );
          }),
        (t.AF.id = t.AF.id || i),
        (t.AF.plugins = {}),
        (o = e.createElement(n)),
        (p = e.getElementsByTagName(n)[0]),
        (o.async = 1),
        (o.src =
          'https://websdk.appsflyer.com?' +
          (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
          (i.length > 0 ? 'af_id=' + i : '')),
        p.parentNode.insertBefore(o, p);
    })(
      window,
      document,
      'script',
      0,
      'AF',
      /Android/i.test(window.navigator.userAgent) ? 'pba,banners' : 'pba',
      {
        pba: { webAppId: AppsflyerWebKey },
        banners: { key: AppsflyerBannerKey }
      }
    );
    window.AF('banners', 'showBanner');
    const CUID = getLocalStorage(USER_ID) || getLocalStorage(GUEST_TOKEN);
    if (!isServer() && window && window.AF) {
      window.AF('pba', 'setCustomerUserId', CUID);
    }
  }
};

export const jusPayScriptAdder = () => {
  const juspaySDK = document.getElementById('juspaySDK');
  if (!juspaySDK) {
    const juspayScript = document.createElement('script');
    juspayScript.setAttribute('id', 'juspaySDK');
    juspayScript.setAttribute('src', 'https://payments.juspay.in/web/PIL.js');
    juspayScript.setAttribute('defer', 'defer');
    document.head.appendChild(juspayScript);
  }
  return null;
};

export const ctScriptAdder = (countryCode = 'IN') => {
  const ct = document.getElementById('ctscript');
  if (!ct) {
    window.ct_account_id =
      countryCode.toLowerCase() === 'in'
        ? process.env.CLEVERTAP_ACCOUNT_ID
        : process.env.CLEVERTAP_ACCOUNT_ID_GLOBAL;
    const ctScript = document.createElement('script');
    ctScript.setAttribute('id', 'ctscript');
    const ctPath = `https://www.zee5.com/clevertapScript.js?ver=${process.env.APP_VERSION}`;
    ctScript.setAttribute('src', ctPath);
    ctScript.setAttribute('defer', 'defer');
    document.head.appendChild(ctScript);
    ctScript.onload = function () {
      // Delaying the ct notification by 6 seconds
      setTimeout(() => {
        clevertapWebpushMethod();
      }, 6000);
    };
  }
};

export const loadTCLoginScript = (
  getTrueCallerData,
  trueCallerNotInstalled,
  userMobile,
  toggleRegisterScreen,
  setErrorAndLoader,
  setLoginSuccess,
  toggleMobilePopup
) => {
  window.location = trueCallerUrl();
  setTimeout(() => {
    if (document.hasFocus()) {
      // callback action that true caller is not there
      trueCallerNotInstalled();
    } else {
      // trigger true caller mixpanel popup launch
      // callback action that true caller is there
      const intervalCheck = setInterval(() => {
        if (document.hasFocus()) {
          // call action for polling
          getTrueCallerData(
            userMobile,
            toggleRegisterScreen,
            () => {},
            false,
            setErrorAndLoader,
            setLoginSuccess,
            toggleMobilePopup
          );
          clearInterval(intervalCheck);
        } else {
          // corner case handling to be added if required
        }
      }, 100);
    }
  }, 600);
};

// For TrueCaller Guest Checkout Flow
export const loadTCGuestCheckoutLogin = (
  getTrueCallerData,
  trueCallerNotInstalled,
  userMobile,
  toggleRegisterScreen,
  chooseAnotherMobile
) => {
  window.location = trueCallerUrl();
  setTimeout(() => {
    if (document.hasFocus()) {
      // callback action that true caller is not there
      trueCallerNotInstalled();
    } else {
      // trigger true caller mixpanel popup launch
      // callback action that true caller is there
      const intervalCheck = setInterval(() => {
        if (document.hasFocus()) {
          // call action for polling
          getTrueCallerData(
            userMobile,
            toggleRegisterScreen,
            chooseAnotherMobile,
            true
          );
          clearInterval(intervalCheck);
        } else {
          // corner case handling to be added if required
        }
      }, 100);
    }
  }, 600);
};

export const loadScripts = (countryCode = 'IN') => {
  defferedThirdPartyScriptsAdder(countryCode);
  GtmScriptAdder(countryCode);
  appsFlyerScriptAdder();
  // castScriptAdded();
  trackAppVersion();
  setCustomAttribute('releaseVersion', process.env.APP_VERSION as string);
};

export const fbqTrack = (pixelEvent, eventId) => {
  const customParams = {
    custom_id: eventId
  };

  if (window.fbq) {
    fbq('track', pixelEvent, customParams);
  } else {
    PIXEL_EVENTS.push({ pixelEvent, customParams });
  }
};

export const fbqDeferredEventsTrack = () => {
  PIXEL_EVENTS.forEach((event) => {
    fbq('track', event.pixelEvent, event.customParams);
  });
};
